/**
 * @generated SignedSource<<2a67316a696eda7a13f0db36296e4934>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UserPaginatorSearchOverlayTokenField_UserValue_userQuery$variables = {
  id: string;
};
export type UserPaginatorSearchOverlayTokenField_UserValue_userQuery$data = {
  readonly user: {
    readonly id: string;
    readonly name: string;
  };
};
export type UserPaginatorSearchOverlayTokenField_UserValue_userQuery = {
  response: UserPaginatorSearchOverlayTokenField_UserValue_userQuery$data;
  variables: UserPaginatorSearchOverlayTokenField_UserValue_userQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserPaginatorSearchOverlayTokenField_UserValue_userQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserPaginatorSearchOverlayTokenField_UserValue_userQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7d2351a0394c9439245bee2c15bcd63a",
    "id": null,
    "metadata": {},
    "name": "UserPaginatorSearchOverlayTokenField_UserValue_userQuery",
    "operationKind": "query",
    "text": "query UserPaginatorSearchOverlayTokenField_UserValue_userQuery(\n  $id: ID!\n) {\n  user(id: $id) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "5f3ca9b809773abccb4dfbe32ce22256";

export default node;
